import BackIcon from 'assets/Icons/modals/BackIcon';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PasswordResetMessageProps {
  message: string;
}

function PasswordResetMessage({ message }: PasswordResetMessageProps) {
  const navigate = useNavigate();
  return (
    <>
      <div className={`text-lg px-8 mb-8 text-center`}>{message}</div>
      <div className="flex justify-center items-center space-x-3 ">
        <SecondaryButton
          buttonLabel="Back"
          iconLeft={<BackIcon />}
          onClick={() => navigate('/')}
          variant="default"
          size="px-4 w-auto !bg-primary1 text-primary2"
        />
      </div>
    </>
  );
}

export default PasswordResetMessage;
